export default "__VITE_ASSET__dcb8a0bb__"